module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_302936.0cf56a48.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetATF/FormatoSimplificado_302936.pdf
// module id = 809
// module chunks = 0